export const COLORS = [
  '#57B8FF', //blue
  '#FF857A', //red
  '#57EA88', //green
  '#FFBA64', //orange
  '#C38DFF', //purple
  '#75ECDE', //turquoise
];
